import { Fab } from "@mui/material";
import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 110) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const onClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    isVisible && (
      <Fab
        href="#"
        onClick={onClick}
        id="scroll-top"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
          backgroundColor: "var(--color-fourth)",
          borderRadius: "50%",
          height: "50px",
          width: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: "18px",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
        }}
      >
        <FaArrowUp style={{ margin: "0", padding: "0" }} />{" "}
        {/* Icon inside the button */}
      </Fab>
    )
  );
};

export default ScrollTop;
